import React from 'react';

import './Freezer.scss';

import air3 from './../assets/images/air3.png';
import pic1 from './../assets/images/pic1.webp';
import pic2 from './../assets/images/pic2.jpg';
import pic3 from './../assets/images/pic3.jpg';

const Freezer = () => {
  return (
    <>
      <div className='freeze__container'>
        <div className='top__freeze'>
          <div className='text__freeze'>
            <h2 className='freeze__title'>
              Construction of Refrigerated Freezers
            </h2>
            <p className='freeze__content'>
              Construction of industrial refrigeration or freezing chambers is a guarantee of efficient business, preservation of high quality products without production costs and full compliance of cooling conditions with the exhibited technical requirements.
            </p>
          </div>
          <div className='img__freeze'>
            <img className='picture__of' src={air3} alt='air_freezer'></img>
          </div>
        </div>
        <div className='middle__freeze'>
          <div className='middle__item--primary'>
            <h3 className='mid__title'>
              Peculiarities of construction of cold <br></br> and freezing chambers
            </h3>
            <p className='mid__text'>
              Industrial refrigeration chambers differ from domestic or commercial not only in capacity, but also in the principle of composition, installation. The equipment used in industrial scale for cooling products is made of sandwich panels of refrigerated type with the use of door block and racks. The number of components for the construction of the chamber is selected individually according to the project and depends on the required volume of the chamber, dimensions and requirements set out to it. Modern freezing, refrigerated chambers can be made in any size. For this purpose, a frame is manufactured, which provides the strength of the structure and guarantees the safety of its operation. As a result, an industrial refrigerator made of sandwich panels fully complies with safety standards, requirements for operation and storage of products.
            </p>
          </div>
          <div className='middle__item'>
            <h3 className='mid__title'>
              Why is it profitable to build cold storage facilities?
            </h3>
            <p className='mid__text'>
              Thanks to the study of the specifics of the products for the storage of which it is planned to build a cold room, it is possible to achieve high results. With the help of correctly performed calculations, selection of materials and equipment, manufacturers and realizers can qualitatively store food, beverages, medicines, floral and fur products. Refrigerated warehouse will maintain the optimal temperature for a particular group of products eliminates production costs for the owner.
            </p>
          </div>
        </div>
        <div className='bottom__freeze'>
          <h4 className='mid__bot__title'>
            Advantages of building industrial cold storage facilities
          </h4>
           <div className='freeze__bot__wrap'>
            <div className='wrap__bot__item'>
              <div className='img__item'>
              <img className='pic__of' src={pic1} alt='pic1'></img>
              </div>
              <div className='content__item'>
                <h5 className='subtitle__item'>
                Modern business solution
                </h5>
                <p className='text__item'>
                The use of modern construction technologies and energy-saving equipment allows you to create an optimal solution with ideal conditions for the business owner.
                </p>
              </div>
            </div>
            <div className='wrap__bot__item'>
              <div className='content__item'>
                <h5 className='subtitle__item'>
                Unique project
                </h5>
                <p className='text__item'>
                The diversity of storage products precludes the use of standard projects. This implies the construction of a unique composition with the most suitable characteristics for a particular group of goods.
                </p>
              </div>
              <div className='img__item'>
              <img className='pic__of' src={pic2} alt='pic2'></img>
              </div>
            </div>
            <div className='wrap__bot__item'>
              <div className='img__item'>
              <img className='pic__of' src={pic3} alt='pic3'></img>
              </div>
              <div className='content__item'>
                <h5 className='subtitle__item'>
                High-quality materials
                </h5>
                <p className='text__item'>
                All materials used in the construction of the cold room are authorized by sanitary services, have certificates and can be used in the food industry.
                </p>
              </div>
            </div>
           </div>
        </div>
      </div>
    </>
  );
};

export default Freezer;